import { render, staticRenderFns } from "./dashboardGreetingBox.vue?vue&type=template&id=c9d51068&scoped=true&"
import script from "./dashboardGreetingBox.vue?vue&type=script&lang=js&"
export * from "./dashboardGreetingBox.vue?vue&type=script&lang=js&"
import style0 from "./dashboardGreetingBox.vue?vue&type=style&index=0&id=c9d51068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d51068",
  null
  
)

export default component.exports